<template>
  <section>
    <h3 class="section__subtitle">{{ title }}</h3>
    <article class="section__container">
      <TypeImportItem
        v-for="option in options"
        :key="option.title"
        :value="selected"
        :option="option"
        @update:value="selected = $event"
      />
    </article>
  </section>
</template>

<script>
import { defineComponent } from "vue";

import { ImportTypeName } from "@/app/imports/utils/constants";

import TypeImportItem from "@/app/imports/components/pickers/TypeImportItem.vue";

export default defineComponent({
  components: {
    TypeImportItem,
  },
  props: {
    value: {
      required: true,
      type: Number,
    },
    title: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
  methods: {
    name(value) {
      if (!value) return;
      return ImportTypeName[value];
    },
  },
});
</script>

<style lang="sass" scoped>
.section
  &__subtitle
    font-size: $font-medium
    color: $gray-9
    border-bottom: $border-normal
    padding-bottom: 8px

  &__container
    margin: 12px 0
    // display: grid
    // grid-template-columns: repeat(5, minmax(0, 1fr))
    display: flex
    flex-direction: column
    gap: 12px
</style>
